import styled, { keyframes } from 'styled-components';

import bkImg from 'ui/assets/img/bg-partner-definitive.webp';
import LoaderSVG from 'ui/assets/img/F2m-loader.svg';
import { pxToRem } from 'utils/scss';

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity:1
  }
`;

export const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: url(${bkImg});
  background-position: top left;
  background-size: cover;
  background-repeat: no-repeat;
  animation: ${opacity} 1s linear forwards;
`;

export const LoaderComponent = styled.div`
  width: ${pxToRem('150px')};
  height: ${pxToRem('150px')};
  color: ${({ theme }) => theme.colors.white};
`;

export const LoaderIcon = styled.div`
  background: url(${LoaderSVG});
  height: 100%;
  background-repeat: no-repeat;
`;
